import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import { shadcn } from "@clerk/ui/themes";
import "@/index.css";
import App from "@/App";

function isClerkNode(el) {
  if (!el || el.id === "root") return true;
  const id = String(el.id || "").toLowerCase();
  const cls = typeof el.className === "string" ? el.className : (el.className?.baseVal || "");
  if (id.includes("clerk") || cls.includes("cl-") || el.hasAttribute?.("data-clerk")) return true;
  // Clerk v6 often portals a classless wrapper around cl-* internals.
  if (el.querySelector?.('[class*="cl-"], [id*="clerk"], iframe[src*="clerk"]')) return true;
  return false;
}

// Hide Emergent "made with" badges only — never all position:fixed body nodes
// (Clerk's modal overlay is a fixed body portal).
const removeBadges = () => {
  document.title = "MarkovLab | Options Intelligence";
  const observer = new MutationObserver(() => {
    document.querySelectorAll('a[href*="emergent"], div[class*="emergent"], [data-emergent]').forEach(el => {
      if (isClerkNode(el)) return;
      el.style.display = "none";
      el.style.visibility = "hidden";
    });
    if (document.title !== "MarkovLab | Options Intelligence") {
      document.title = "MarkovLab | Options Intelligence";
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  observer.observe(document.head, { childList: true, subtree: true });
};
setTimeout(removeBadges, 1000);

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      signInUrl="/login"
      signUpUrl="/sign-up"
      afterSignInUrl="/dashboard"
      afterSignUpUrl="/dashboard"
      signInFallbackRedirectUrl="/dashboard"
      signUpFallbackRedirectUrl="/dashboard"
      appearance={{
        theme: shadcn,
        // shadcn theme maps colorBackground → var(--card), but our --card is
        // Tailwind HSL channels ("0 0% 7%"), not a CSS color — the modal
        // paints transparent and the Scanner table shows through. Same for
        // colorModalBackdrop (var(--color-black) is undefined here).
        variables: {
          colorBackground: "#111111",
          colorForeground: "#F4F4F5",
          colorModalBackdrop: "rgba(0, 0, 0, 0.75)",
          colorPrimary: "#00c896",
          colorPrimaryForeground: "#0a0a0a",
          colorInput: "#1A1A1A",
          colorInputForeground: "#F4F4F5",
          colorMuted: "#1A1A1A",
          colorMutedForeground: "#A1A1AA",
          colorNeutral: "#F4F4F5",
          colorDanger: "#EF4444",
          colorRing: "#D4D4D8",
        },
      }}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
